import styled from 'styled-components';
import DocumentsWelcome from './DocumentsWelcome';
import { colorSchema, media } from 'utils/style';

export default styled(DocumentsWelcome)`
  background: ${colorSchema('white')};
  border-top: 1px solid ${colorSchema('grey700')};
  height: auto;
  min-height: 100%;
  margin: 0 -1rem;
  padding: 0 1rem;

  ${media.greaterThan('tablet')`
    border: 0;
    margin: 0;
    padding: 0;
  `}

  .documents-welcome {
    display: grid;
    flex-direction: column;
    margin: 0 0.6rem;
    grid-gap: 12px;
    grid-template-columns: repeat(4, 1fr);
    flex-direction: column;

    ${media.greaterThan('tablet')`
      grid-template-columns: repeat(12, 1fr);
      max-width: 1128px;
      margin: 0 auto;
    `}

    &__container {
      border: 0;
      display: flex;
      flex-direction: column;
      margin-top: 4.8rem;
      padding: 0;
      grid-column: 1 / span 4;
      grid-row: 1;

      ${media.greaterThan('tablet')`
        border: 1px solid ${colorSchema('grey300')};
        grid-column: 1 / span 12;
        margin-top: 6.8rem;
        padding: 2.4rem 3.2rem;
    `}
    }
    &__title {
      color: ${colorSchema('grey900')};
      font-size: 2.1rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 2.4rem;
      text-align: center;
    }

    &__description {
      color: ${colorSchema('grey800')};
      margin-bottom: 2.4rem;
      text-align: center;
    }

    &__bullet-container {
      margin: 0 auto 2.4rem;
      width: 80%;
    }

    &__bullet {
      align-items: flex-start;
      display: flex;
      margin-bottom: 2.4rem;

      ${media.greaterThan('tablet')`
        align-items: center;
      `}
    }

    &__bullet-icon {
      align-items: center;
      background: ${colorSchema('grey200')};
      border-radius: 50%;
      display: flex;
      flex-shrink: 0;
      height: 28px;
      justify-content: center;
      margin-right: 1.6rem;
      width: 28px;
    }

    &__bullet-text {
      &--bold {
        margin-right: 0.4rem;
      }
    }

    &__action {
      align-self: center;
      display: flex;
      max-width: 350px;
      width: 100%;
    }
  }
`;
